<template>
  <div class="expert-search1 max-content" style="margin-bottom: 60px;">
    <img src="../../../assets/images/System/search_top.png" class="top-img" />
    <div class="content">
      <div class="head">
        <van-search shape="round" v-model="name" placeholder="请输入专家姓名" @input="searchExpert" />
      </div>
      <div class="names">
        <p class="whole">全部专家</p>
        <van-index-bar :index-list="indexList" ref="indexbar">
          <div v-for="(item, index) in indexList" :key="item">
            <van-index-anchor :index="item" @click.native="searchAllByPin(item, index)" />
            <div v-for="(row, index) in peopleList[item]" :key="index" class="item" @click="goDetail(row.id)">
              <div class="cell-avatar">
                <img v-if="row.photo" :src="row.photo" alt="" />
                <img src="../../../assets/images/System/people_default.png" alt="" v-else />
              </div>
              <div class="cell-name">
                <h4>{{ row.name }}</h4>
                <p>{{ row.company }}</p>
              </div>
            </div>
          </div>
        </van-index-bar>
      </div>
    </div>
    <tabbar :active="index" style="z-index:1000;"></tabbar>
  </div>
</template>
<script>
import Tabbar from '../components/Tabbar'
import { SearchAllWriters, ExpertSearch, ButtonDetail } from '../../../config/interface.js'
export default {
  components: {
    Tabbar
  },
  data() {
    return {
      //peopleList:[],
      name: "",
      indexList: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      peopleList: {},
      button_id: this.$route.query.button_id ? this.$route.query.button_id : this.$route.query.b_id,
      expand: [],
      index: 5
    }
  },
  computed: {
    meeting_id() {
      return this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id
    }
  },
  mounted() {
    // this.searchExpert();
    this.getButtonData();
    for (let i = 0; i < this.indexList.length; i++) {
      this.expand.push(0);
      this.$set(this.peopleList, this.indexList[i], [])
    }
    document.title = '讲者首页';
    if (common.is_weixin()) {
      common.wxShare("讲者首页@血管资讯", '血管外科领域专家查询一览', 'cdn.edstatic.com/203012120000/bca5bbcde6b65142646518943d71936a/2020/09/8e44215d-f687-4be7-8ced-81c3c880587a.png');
    }

  },
  methods: {
    searchAllByPin(key, index) {
      if ((this.name == null || this.name == "")) {
        if (this.expand[index] == 0) {
          const url = SearchAllWriters;
          const method = 'POST'
          let params = {
            ren_ping: key,
          };
          fetch(url, params, method).then((res) => {
            if (res.code == 0) {
              this.$set(this.expand, index, 1)
              this.$set(this.peopleList, key, res.data)
            }
          })

        }
        else {
          this.$set(this.peopleList, key, [])
          this.$set(this.expand, index, 0)
        }

      }

    },
    goDetail(id) {
      this.$router.push({
        path: "/vascularNews/expert/index",
        query: {
          writer_id: id
        },
      });
    },
    //获取按钮信息
    getButtonData() {
      if (this.button_id) {
        const url = ButtonDetail;
        let params = {
          button_id: this.button_id
        }
        const method = "POST";
        fetch(url, params, method)
          .then((res) => {
            if (res.code == 0) {
              if (common.is_weixin()) {
                let data = res.data;
                common.wxShare(data.share_title, data.share_sub_title, data.share_img);
              }
            }
          })

      }
    },
    searchExpert(val) {
      if (val) {
        const url = ExpertSearch;
        const method = 'POST'
        let params = {
          keywords: val,
          group_by: 1
        };
        fetch(url, params, method).then((res) => {
          if (res.code == 0) {
            this.indexList = Object.keys(res.data).sort();
            this.peopleList = res.data;
          }
        })
      }
      else {
        this.indexList = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
        this.peopleList = {};
        this.expand = [];
        for (let i = 0; i < this.indexList.length; i++) {
          this.expand.push(0);
          this.$set(this.peopleList, this.indexList[i], [])
        }
      }
    },
  },
};
</script>
<style lang="scss">
.expert-search1 {
  position: relative;
  z-index: 1;

  .top-img {
    width: 100%;
    height: 120px;
    // background: red;
  }

  .content {
    background: white;
    position: absolute;
    top: 60px;
    z-index: 2;
    width: 90%;
    left: 5%;

    .head {
      border-radius: 1rem;
    }

    .whole {
      font-size: 16px;
      padding: 5px 10px 10px 15px;
      color: #535353;
    }

    .van-index-anchor {
      background: #f5f5f5;
      border-top: 10px solid white;
      border-bottom: 10px solid white;
      cursor: pointer;
    }

    .item {
      padding: 10px;
      // border-bottom:1px solid #F7F7F7 ;
      display: flex;

      div {
        display: inline;
        vertical-align: middle;

        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
      }

      .cell-name {
        padding: 0 10px;
        width: 90%;
        border-bottom: 1px solid #f7f7f7;

        p {
          padding: 0;
          margin: 0;
          color: #666;
        }

        h4 {
          font-size: 14px;
          color: #535353;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Expert/SearchAll.vue